const DEFAULT_SIDES = {
  sideX: "left",
  sideY: "top"
};
export {
  DEFAULT_SIDES
};
//# sourceMappingURL=adaptiveOriginConstants.js.map
